import React from 'react';
import styled from 'styled-components';
import colors from '../styles/colors';
import Logo from './Logo';
import Navigation from './Navigation';
import PhoneNumber from './PhoneNumber';
import HeaderStripes from '../images/client/header_stripes.png';
import { Image } from 'react-bootstrap'

// TODO: change styling to have a lower maximum height for the header with a hook that is changed whenever the navigation bar is expanded to heighten that limit

const BaseSiteMeta = ({ className, content, expandedConst, expandedFunc }) => {
  
  return (
  <div className={className}>
    <div className={`headerWrapper`}>
      <div className="headerStripes">
        <Image src={HeaderStripes} fluid />
      </div>
      <div className="header">
        <div className='contact'>
          <PhoneNumber phone={content.phone} />
          {/* <div className="signin">Sign-in</div> */}
        </div>
        <Navigation onExpand={expandedFunc} />
      </div>
    </div>
  </div>
)};

const SiteMeta = styled(BaseSiteMeta)`
  display: flex;
  align-content: flex-end;
  .headerStripes {
    align-self: flex-start;
    background: ${colors.white};
    height: 100%;
    margin-bottom: 0;
    img {
      height: 100%;
    }
  }

  .headerWrapper {
    display: flex;
    height: 100%;
    width: 100%;
    padding-right: 0vw;
  }

  .header {
    background: ${colors.lightBlue};
    padding-left: 25px;
    width: 70vw;
    max-width: 1000px;
    .contact {
      display: flex;
      justify-content: flex-end;
      padding-top: 10px;
      padding-right: 10px;
    }
    .signin {
      margin-left: 10px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
`;

const BaseHeader = ({ className, content }) => {
  const [navExpanded, setNavExpanded] = React.useState(false)
  const changeExpanded = () => {
    setNavExpanded(!navExpanded)
  }
  return (
  <div className={`${className} ${navExpanded ===  true ? 'navExpanded' : ''}`}>
    <Logo />
    <SiteMeta content={content} expandedConst={navExpanded} expandedFunc={changeExpanded}/>
  </div>
)};

const Header = styled(BaseHeader)`
  display: flex;
  height: 100%;
  max-height: 125px;
  @media screen and (max-width: 992px){
    max-height: 150px;
  }
  /* @media screen and (max-width: 576px) {
    
  } */
  background-color: #ffffff;
  max-width: 1366px;
  @media screen and (max-width: 1200px){
    &.navExpanded {
      max-height: 500px;
    }
  }

`;

export default Header;
